module.exports = {"TXTWCL_Total_you_receive":{"id":"TXTWCL_Total_you_receive","defaultMessage":"Du modtager i alt"}}